import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '../widgets/Dialog';
import Button from '../widgets/button';
import TextField from '../widgets/TextField';
import { formatDate } from '../../utils/utils';

class StartContractDialog extends React.Component {
	constructor(props, context) {
		super(props, context);

		this.state = {
			periodName: formatDate(new Date(), 'MMMM yy')
		};
	}

	render() {
		return (
	<Dialog
		title="Start Contract?"
		actions={
			<React.Fragment>
				<Button
					label="Yes"
					primary={true}
					onClick={() => this.props.onStartContract(this.state.periodName)}
				/>,
				<Button
					label="No"
					primary={false}
					onClick={this.props.onClose}
				/>
			</React.Fragment>
		}
		open={this.props.show}
		onClose={this.props.onClose}
	>
		<p>Note that you will not be able to edit tendered Schedules of Rates once the contract has started.</p>
		<TextField
			value={this.state.periodName}
			onChange={e => this.setState({ periodName: e.target.value })}
			label="Period Name"
			fullWidth={true}
		/>
	</Dialog>
		);
	}
}

StartContractDialog.propTypes = {
	show: PropTypes.bool.isRequired,
	onStartContract: PropTypes.func.isRequired,
	onClose: PropTypes.func.isRequired
};

export default StartContractDialog;
